import { useQueryClient } from "@tanstack/react-query";
import type { SearchReturnRequestsResponseDto } from "../generated/schema";
import { getPublicAuthHeader } from "./return-widget-client";
import { usePublicApiMutation } from "./use-public-api-mutation";

type Params = {
	returnRequestId: string;
};

export function usePublicCancelReturnRequest() {
	const queryClient = useQueryClient();

	return usePublicApiMutation(
		"delete",
		"/public/return-request/{returnRequestId}",
		{
			mapVariables: ({ returnRequestId }: Params) => ({
				params: {
					path: { returnRequestId },
					header: getPublicAuthHeader(),
				},
			}),
			onSuccess: (_data, { returnRequestId }) => {
				queryClient.setQueriesData<SearchReturnRequestsResponseDto>(
					{ queryKey: ["get", "/public/return-request/search"] },
					(old) => {
						if (!old) return old;
						return {
							returnRequests: old.returnRequests.filter((rr) => rr.id !== returnRequestId),
						};
					},
				);
				queryClient.invalidateQueries({
					queryKey: ["get", "/public/return-request/search"],
				});
			},
		},
	);
}
